import type { LegacyRef } from 'react';
import { forwardRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface TabNavComponentProps {
  tabs: ({ name: string; url: string; isEnabled?: boolean } | null)[];
}

function TabNavComponent(
  { tabs }: TabNavComponentProps,
  ref: LegacyRef<HTMLDivElement>
) {
  const navigate = useNavigate();
  const activeUrl = useLocation().pathname;

  // Navigate to path.
  const handleNavigation = (path: string) => {
    navigate(`${path}`);
  };

  return (
    <div ref={ref}>
      <ul className="uk-subnav uk-subnav-pill" uk-margin="true">
        {tabs && tabs.length > 0 ? (
          tabs.map((tab) => {
            if (tab === null) {
              return;
            }
            const isEnabled =
              tab.isEnabled !== undefined ? tab.isEnabled : true;
            return (
              <li
                key={tab.url}
                className={`${activeUrl === tab.url ? 'uk-active' : ''}`}
              >
                <button
                  onClick={() => handleNavigation(tab.url)}
                  style={{
                    cursor: isEnabled ? 'pointer' : 'not-allowed',
                    opacity: isEnabled ? 1 : 0.5,
                  }}
                  disabled={!isEnabled}
                >
                  {tab.name}
                </button>
              </li>
            );
          })
        ) : (
          <div>Pas d'onglets à afficher</div>
        )}
      </ul>
      <hr></hr>
    </div>
  );
}

export default forwardRef(TabNavComponent);
